// extracted by mini-css-extract-plugin
export default {"container":"notification_container__4p8MO","notification":"notification_notification__eLmmv","success":"notification_success__vn4Rh","error":"notification_error__J6mI0"};